import Section from "../layouts/Section";
import {useEffect, useState} from "react";
import useFetch from "../../hooks/useFetch";
import CONFIG from "../../config/_config";
import CategoriesList from "./CategoriesList";
import {Box, Divider, Stack, Typography, useTheme} from "@mui/material";
import ProductList from "./ProductList";
import {useTranslations} from "../../store/LanguageProvider";


const Menu = () => {
    const {makeRequest, response} = useFetch();
    const [menu, setMenu] = useState(null);
    const theme = useTheme();
    const {currentLang, translations} = useTranslations();

    useEffect(() => {
        makeRequest(CONFIG.apiUrl + 'menu_ajax.php', 'post', {getCategoriesAndProducts: 1})
    }, []);

    useEffect(() => {
        if (!response)
            return;
        if (response.state === 'success'){
            setMenu(response.data);
        }
    }, [response]);

    let categories = []
    if (menu) {
        categories = menu
            .filter(cat => cat.products.length > 0)
            .map(cat => {
                let name = cat.name;
                if (cat.translations && cat.translations[currentLang] && cat.translations[currentLang].name){
                    name = cat.translations[currentLang].name;
                }

                return {
                    id: cat.id,
                    name
                }
        })
    }

    const onCategorySelected = (cId) => {

    }

    return <>
        {menu && <>
            <Section title={translations.menu_title} id='menu'>
                <Stack direction='column'>
                    <Box position='sticky' sx={{top: 70, backgroundColor: theme.palette.brLight.main, zIndex: 100}}>
                        <CategoriesList data={categories} onCategorySelected={onCategorySelected} />
                        <Divider variant='middle' sx={{borderColor: theme.palette.brLight.dark, borderWidth: '1px'}} />
                    </Box>
                    <ProductList data={menu} />
                    <Box mt={2}>
                        <Typography variant='body2' textAlign='left' >{translations.adds}</Typography>
                        <Typography variant='body2' textAlign='left'>{translations.adds_text}</Typography>
                        <Typography variant='body2' textAlign='left' mt={1}>{translations.frozen_product}</Typography>
                    </Box>
                </Stack>
            </Section>
        </>}
    </>
}

export default Menu;